import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { StageReadinessRow } from '@/hooks/useDviStageReadiness';
import { pct } from './stageColors';

interface Props {
  rows: StageReadinessRow[];
  onSelect: (row: StageReadinessRow) => void;
}

export function BestPerformersPanel({ rows, onSelect }: Props) {
  const eligible = rows.filter((r) => r.total_samples >= 10);
  const top = [...eligible].sort((a, b) => b.component_accuracy - a.component_accuracy).slice(0, 5);
  const fastest = [...eligible].sort((a, b) => b.velocity_30d - a.velocity_30d).slice(0, 5);
  const closeToGrad = [...eligible]
    .filter((r) => r.component_stage !== 'automation')
    .sort((a, b) => b.component_accuracy - a.component_accuracy)
    .slice(0, 5);
  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-sm">Best Performers</CardTitle></CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
        <div>
          <div className="text-muted-foreground mb-1">Highest accuracy</div>
          {top.map((r) => (
            <button key={`t-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· {pct(r.component_accuracy)}</span>
            </button>
          ))}
        </div>
        <div>
          <div className="text-muted-foreground mb-1">Fastest growing</div>
          {fastest.map((r) => (
            <button key={`f-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· +{(r.velocity_30d * 100).toFixed(1)}%</span>
            </button>
          ))}
        </div>
        <div>
          <div className="text-muted-foreground mb-1">Closest to graduation</div>
          {closeToGrad.map((r) => (
            <button key={`c-${r.component}-${r.condition_type}`} onClick={() => onSelect(r)} className="block text-left w-full hover:underline">
              {r.component} <span className="text-muted-foreground">· {pct(r.component_accuracy)}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
